import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useLiveAlarms } from "../../live/LiveProvider";
import { useOrg } from "../org/OrgProvider";
import { alarmBadge } from "./alarms";
import { allAlarmsQuery } from "./queries";

/**
 * The count of alarms not yet acknowledged, next to Alarms in the navigation (WEB-ALM-01): red when one of them is
 * critical, with the words for screen readers. Nothing while there are none or the list cannot be read. Live `alarm`
 * messages move it at once (live 0.3.0, WEB-ALM-05).
 */
export function AlarmsBadge() {
  const { t } = useTranslation();
  const { orgId } = useOrg();
  const alarms = useQuery(allAlarmsQuery(orgId ?? ""));
  // The badge is on every screen, so it holds the live alarms subscription for the count and the Alarms screen.
  useLiveAlarms();
  if (!alarms.data) return null;
  const { count, critical } = alarmBadge(alarms.data);
  if (count === 0) return null;
  return (
    <>
      <span
        aria-hidden="true"
        data-critical={critical || undefined}
        className={`ml-auto rounded-full px-2 text-xs font-semibold ${critical ? "bg-red-700 text-white" : "bg-gray-200 text-gray-900"}`}
      >
        {count}
      </span>
      <span className="sr-only">{t(critical ? "alarms.badgeCritical" : "alarms.badge", { count })}</span>
    </>
  );
}
